import { api } from '@/store/interfaces/apiCraft'
import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    global: [],
    categories: [],
    homepage: {},
    page: {},
    project: {},
    showreel: [],
    promises: {},
    loaded: true,
    globalLoaded: true,
    projects: {},
    endPage: {}
  },

  getters: {
    global: state =>{
      return state.global
    },
    menu: state =>{
      return state.global.brightMenu
    },
    contact: state =>{
      return state.global.brightContact
    },
    page: state =>{
      return state.page
    },
    project: state =>{
      return state.project
    },
    // pageBySlug: state => slug => {
    //   return state.entries.find(entry => { return entry.slug === slug })
    // },
    homepage: state =>{
      return state.homepage
    },
    categories: state =>{
      return state.categories
    },
    promises: state => {
      return state.promises
    },
    promiseBySlug: state => slug => {
      return state.promises[slug]
    },
    promiseByIndex: state => index => {
      return Object.values(state.promises).find(entry => { return entry.index === index })
    },
    loaded: state =>{
      return state.loaded
    },
    globalLoaded: state =>{
      return state.globalLoaded
    },
    projects: state =>{
      return state.projects
    },
    categories: state =>{
      return state.categories
    },
    endPage: state =>{
      return state.endPage
    }
  },

  actions: {
    global({ commit, state }) {
      commit('globalLoaded', false)

      return new Promise(resolve => {
        const { request, cache } = api.getGlobal()
        cache.then(res => {
          if (res !== null) {
            commit('global', res.globalSet)
            commit('promises', res.globalSet.brightPromises)
            commit('homepage', res.entry)
            commit('categories', res.categories)
            commit('globalLoaded', true)
            resolve()
          }
        })

        request.then(res => {
          commit('global', res.globalSet)
          commit('promises', res.globalSet.brightPromises)
          commit('homepage', res.entry)
          commit('categories', res.categories)
          commit('globalLoaded', true)
          resolve()
        })
      })
    },
    project ({ commit, state }, slug) {
      commit('loaded', false)

      const { request, cache } = api.getEntry(slug)
      cache.then(res => {
        if (res !== null) {
          commit('project', res)
          commit('loaded', true)
        }
      })

      request.then(res => {
        commit('project', res)
        commit('loaded', true)
      })
    },
    projects ({ commit, state }, categories) {
      const { request, cache } = api.getProjects(categories)
      commit('loaded', false)
      
      return new Promise(resolve => {
        cache.then(res => {
          if (res !== null) {
            commit('projects', res)
            commit('loaded', true)
            resolve()
          }
        })

        request.then(res => {
          commit('projects', res)
          commit('loaded', true)
          resolve()
        })
      })
    },
    promise ({ commit, state }, slug) {
      return new Promise(resolve => {
        const { request, cache } = api.getPromise(slug)
        cache.then(res => {
          if (res !== null) {
            commit('promise', res)
            commit('loaded', true)
            resolve()
          }
        })

        request.then(res => {
          commit('promise', res)
          commit('loaded', true)
          resolve()
        })
      })
    },
    page ({ commit, state }, slug) {
      commit('loaded', false)

      return new Promise((resolve, reject) => {
        const { request, cache } = api.getPage(slug)

        cache.then(res => {
          if (res !== null) {
            commit('page', res)
            commit('loaded', true)
          }
        })

        request.then(res => {
          commit('page', res)
          commit('loaded', true)
          resolve()
        }).catch(err => {
          commit('loaded', true)
          reject(err)
        })
      })
    },
    endPage ({ commit, state }) {
      commit('loaded', false)

      return new Promise((resolve, reject) => {
        const { request, cache } = api.getEndPage()

        cache.then(res => {
          if (res !== null) {
            commit('endPage', res)
            commit('loaded', true)
          }
        })

        request.then(res => {
          commit('endPage', res)
          commit('loaded', true)
          resolve()
        }).catch(err => {
          commit('loaded', true)
          reject(err)
        })
      })
    }
  },

  mutations: {
    loaded (state, payload) {
      state.loaded = payload
    },
    globalLoaded (state, payload) {
      state.globalLoaded = payload
    },
    global (state, payload) {
      state.global = payload
    },
    homepage (state, payload) {
      state.homepage = payload
    },
    promises (state, promises) {
      promises.forEach((promise, index) => {
        Vue.set(state.promises, promise.slug, {
          ...state.promises[promise.slug],
          ...promise,
          isFull: promise.typeHandle === 'brightPromiseInteractif',
          next: promises[index + 1] ? promises[index + 1] : null,
          index: index
        })
      })
    },
    promise (state, promise) {
      Vue.set(state.promises, promise.slug, {...state.promises[promise.slug], ...promise, isFull: true})
    },
    page (state, payload) {
      state.page = payload
    },
    project (state, payload) {
      state.project = payload
    },
    projects (state, payload) {
      state.projects = payload
    },
    categories (state, payload) {
      state.categories = payload
    },
    endPage (state, payload) {
      state.endPage = payload
    }
  }
}
